import React from "react";

const UpdateImagesContext = React.createContext();

export default UpdateImagesContext;




